import {url} from '../config';

const LoggingApi = {

    getLoggingDataSize: async (token, id) => {
        const response = await fetch(`${url}log-count/${id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${token}`
            },
        });
        if (response.status === 200) {
            return await response.json();
        }
        else if (response.status === 401) {
            return { error: 'Unauthorized' };
        } else {
            return 0;
        }
    },

    getLoggingDataRange: async (token, id, from, to) => {
        const params = new URLSearchParams({ from, to }).toString();

        const response = await fetch(`${url}log-range/${id}?${params}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${token}`
            }
        });
        if (response.ok) {
            const ret = await response.json();
            return ret;
        }
        else if (response.status === 401) {
            return { error: 'Unauthorized' };
        } else {
            return 0;
        }
    },

    eraseLogging: async (token, id) => {
        const response = await fetch(`${url}log-erase/${id}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${token}`
            },
        });
        if (response.status === 200) {
            const data = await response.json();
            return data;
        }
        else if (response.status === 401) {
            return { error: 'Unauthorized' };
        } else {
            return false;
        }
    },

    setLogging: async (token, id) => {
        const response = await fetch(`${url}log-state/${id}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${token}`
            },
        });
        if (response.status === 200) {
            const data = await response.json();
            return data;
        }
        else if (response.status === 401) {
            return { error: 'Unauthorized' };
        } else {
            return false;
        }
    },

}

export default LoggingApi;
